import React , {useEffect, useRef, useState} from 'react';
import withMultiverseApi from '../../hoc/multiverseApiProvider/withMultiverseApi';
import { MultiverseFile, WithMultiverseApiProps } from '../../hoc/multiverseApiProvider';
import AdminPage from '../../components/adminPage';
import { Accordion, Breadcrumb, Button, Card, Col, Container, Form, ListGroup, ListGroupItem, Modal, OverlayTrigger, Row, Spinner, Tooltip } from 'react-bootstrap';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';

type AdminAgentsPageProps = {

} & WithMultiverseApiProps & RouteComponentProps;




function _AdminAgentsPage( props: AdminAgentsPageProps) {

  const [loading, setLoading] = useState<boolean>(false);
  const [updatingEmbeddings, setUpdatingEmbeddings] = useState<boolean>(false);

  const updateGoogleDocs = async () => {
    setUpdatingEmbeddings(true);
    try {
        const response = await props.multiverse.get<any>('/v2/admin/agents/embedding/process?collection=external_docs')
        alert(JSON.stringify(response));
    } catch (error) {
        console.error(error);
        alert("Error: " + JSON.stringify(error));
    }
    setUpdatingEmbeddings(false);
}


const UpdateEmbeddingsCard = () => {
  return (
    <Card>
      <Card.Header>
        <Card.Title>
          Update Embeddings
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <Form>
          <Form.Group as={Row} controlId="creation_cost" className="align-items-center">
            <Col sm="2">
            {!updatingEmbeddings && <Button variant="primary" style={{width:'100%'}} onClick={updateGoogleDocs}>Update GoogleDocs</Button>}
            {updatingEmbeddings && <Button variant="primary" style={{width:'100%'}} disabled><Spinner animation="border" /></Button>}
            </Col>
            {/* <Form.Control
              type="checkbox" 
              aria-label="Force Update"
            /> */}
          </Form.Group>
        </Form>
      </Card.Body>
    </Card>
  );
};




//   useEffect(() => {
//     props.multiverse.get<TGlobalConfig>("/v2/agents/globalconfig_costs").then((config) => {
//       setGlobalConfig(config);
//       setEditedGlobalConfig(config);
//       setLoading(false);
//     }).catch((err) => {
//       console.error(err);
//       setLoading(false);
//     })
//   }, []);



  return (
    <AdminPage>
      <h4><b><Breadcrumb>
          <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/admin/agents" }}>Agents</Breadcrumb.Item>
          <Breadcrumb.Item active><b>Manage Embeddings</b></Breadcrumb.Item>
      </Breadcrumb></b></h4>

      {!loading && (
        <UpdateEmbeddingsCard
        />
      )}

    </AdminPage>
  );
}
export const AdminAgentsEmbeddingsPage = withRouter(withMultiverseApi(_AdminAgentsPage));

export default AdminAgentsEmbeddingsPage;

